/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import {
  useEffect,
  useState,
  useContext,
  useRef,
  useMemo,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription } from "@repo/ui";
import {
  Grid,
  GridColumn,
  getSelectedState,
  GRID_COL_INDEX_ATTRIBUTE,
} from "@progress/kendo-react-grid";
import { getter, process } from "@progress/kendo-data-query";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { useMaintenanceBulkAssign } from "services/maintenance";
import { StatusContext } from "../constants";
import { fixKendoGridContent, getTicketDetailsPage } from "../utils";
import GridDataCopyCell from "components/copy";
import {
  useExportTasksQuery,
  useGetAvailableColumns,
  useGetTasksQuery,
  useGetUserColumns,
  useGetUserSettings,
  useGetTicketsConfig,
} from "services/dynamic-filtering";
import eventBus from "store/event-emitter";
import DynamicFiltering from "components/dynamicFiltering";
import ColumnActionsCell from "components/dynamicFiltering/column-actions";
import { useUser } from "hooks/use-user";
import { getField } from "components/dynamicFiltering/utils";

export default function DispatcherAllTicketsListV2() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
    group: [],
  });
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedState, setSelectedState] = useState({});
  const [reload, setReload] = useState(false);
  const [userColumns, setUserColumns] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({});

  const { setStatus } = useContext(StatusContext);

  const [filters, setFilters] = useState({
    filters: [],
    period: "all",
    searchString: "",
  });
  const user = useUser();
  const pageSize = 100;
  const _exporter = useRef();
  const dataStateRef = useRef(dataState);
  const DATA_ITEM_KEY = "ticketUniqueId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const {
    mutate: getUserColumns,
    data: userColumnsRes,
    isPending: gettingUserColumns,
    reset: resetUserColumns,
  } = useGetUserColumns();

  const {
    mutate: getAvailableColumns,
    data: availableColumnsRes,
    isPending: gettingAvailableColumns,
  } = useGetAvailableColumns();

  const {
    mutate: getUserSettings,
    data: userSettingsRes,
    isPending: gettingUserSettings,
  } = useGetUserSettings();

  const {
    mutate: getTicketsConfig,
    data: ticketsConfig,
    isPending: gettingTicketsConfig,
  } = useGetTicketsConfig();
  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetTasksQuery();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportTasksQuery();

  const {
    mutate: bulkAssign,
    data: bulkAssignRes,
    isPending: bulkAssigning,
    error: bulkAssignError,
    reset: bulkAssignReset,
  } = useMaintenanceBulkAssign();

  useEffect(() => {
    dataStateRef.current = dataState;
  }, [dataState]);

  useEffect(() => {
    const eventHandler = () => {
      onRefresh();
    };

    const updateColumnHandler = () => {
      getUserColumns("tasks");
      getUserSettings("tasks");
      getAvailableColumns("tasks");
    };
    const actionEventHandler = (payload) => {
      if (payload?.type === "group") {
        const _group = {
          field: payload.field,
          operator: "eq",
          value: payload.value,
        };

        const _dataState = dataStateRef.current;
        const newGroups = [..._dataState.group];

        const existingGroupIndex = newGroups.findIndex(
          (elm) => elm.field === _group.field
        );
        if (existingGroupIndex !== -1) {
          newGroups[existingGroupIndex] = _group;
        } else {
          newGroups.push(_group);
        }
        setExpandedGroups({ [_group.field]: [_group.value] });
        setDataState({
          ..._dataState,
          group: newGroups,
        });
      }
    };
    updateColumnHandler();
    getUserSettings("tasks");
    getTicketsConfig("tasks");
    eventHandler();

    eventBus.on("updateFilters", eventHandler);
    eventBus.on("updateColumns", updateColumnHandler);
    eventBus.on("applyActions", actionEventHandler);

    return () => {
      eventBus.off("updateFilters", eventHandler);
      eventBus.on("updateColumns", updateColumnHandler);
      eventBus.off("applyActions", actionEventHandler);
    };
  }, []);

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
    if (userColumnsRes) {
      const sortedColumns = userColumnsRes.data.columns;
      sortedColumns.sort((a, b) => {
        if (a.order < b.order) {
          return true;
        }
        return false;
      });
      setUserColumns(sortedColumns);
      resetUserColumns();
    }
    if (bulkAssignRes || bulkAssignError) {
      bulkAssignReset();
    }
  }, [allTicketsData, userColumnsRes, bulkAssignRes, bulkAssignError]);

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...filters,
    });
  }, [reload, filters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm, index) => ({
          ...elm,
          selected: false,
          expanded: false,
          ticketUniqueId: `ticket-${elm.requestId}-${index}`,
        }))
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };
  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...filters,
    });
  };
  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...filters,
    });
  };
  const onExpandChange = (event) => {
    const { dataItem } = event;

    if (dataItem.field) {
      const _expandedGroups = { ...expandedGroups };
      const groupsKeys = Object.keys(expandedGroups);
      if (groupsKeys.find((elm) => elm === dataItem.field)) {
        groupsKeys.forEach((elm) => {
          if (elm === dataItem.field) {
            const currentList = expandedGroups[elm];
            const currentItemIndex = currentList.findIndex(
              (item) => item === dataItem.value
            );
            if (currentItemIndex !== -1) {
              _expandedGroups[elm].splice(currentItemIndex, 1);
              if (currentList.length === 0) {
                delete _expandedGroups[elm];
              }
            } else {
              _expandedGroups[elm].push(dataItem.value);
            }
          }
        });
      } else {
        _expandedGroups[dataItem.field] = [dataItem.value];
      }
      setExpandedGroups(_expandedGroups);
    }
  };

  const recursiveSorting = (data, groupIndex) => {
    const _sortedData = data;
    _sortedData.forEach((elm) => {
      const isFieldExpanded = expandedGroups[elm.field];
      if (isFieldExpanded) {
        const _currentItemIndex = isFieldExpanded.findIndex(
          (item) => item === elm.value
        );
        if (_currentItemIndex !== -1) {
          elm.expanded = true;
        } else {
          elm.expanded = false;
        }
      } else {
        elm.expanded = false;
      }
    });
    const _currentGroup = dataState.group[groupIndex];
    const currentGroupIndex = data.findIndex(
      (elm) =>
        elm.field === _currentGroup.field && elm.value === _currentGroup.value
    );
    if (currentGroupIndex !== -1) {
      const currentGroup = _sortedData.splice(currentGroupIndex, 1);
      _sortedData.unshift(currentGroup[0]);
    }
    if (dataState.group.length > groupIndex + 1) {
      _sortedData.forEach((item) => {
        if (item?.items?.length > 0) {
          item.items = recursiveSorting(item.items, groupIndex + 1);
        }
      });
    }
    return _sortedData;
  };

  const groupedData = useMemo(() => {
    const processedData = process(
      tickets.map((elm) => ({
        ...elm,
        [SELECTED_FIELD]: selectedState[idGetter(elm)],
      })) || [],
      {
        ...dataState,
      }
    );

    return processedData;
  }, [tickets, dataState, selectedState]);

  const sortedData = useMemo(() => {
    const _sortedData = groupedData;
    const dataGroups = dataState.group;
    if (dataGroups.length > 0) {
      _sortedData.data = recursiveSorting(groupedData.data, 0);
    }
    return [..._sortedData.data];
  }, [groupedData, expandedGroups]);

  const columnsToRender = useMemo(() => {
    if (userColumns.length === 0) {
      return availableColumnsRes?.data?.columns || [];
    }
    return userColumns;
  }, [availableColumnsRes, userColumns]);

  function CaseNoColumn(cellProps) {
    const {
      dataItem,
      field,
      //  ...otherProps
    } = cellProps;
    // const navigationAttributes = useTableKeyboardNavigation(cellProps.id);
    return (
      <GridDataCopyCell
        dataItem={dataItem}
        field={field}
        // tdProps={{
        //   ...navigationAttributes,
        //   "aria-selected": "false",
        //   ...otherProps,
        //   ...{ [GRID_COL_INDEX_ATTRIBUTE]: cellProps.columnIndex },
        // }}
        customCell={
          <Link
            onClick={() => {
              setStatus("all");
            }}
            title={dataItem.caseNo}
            to={getTicketDetailsPage(dataItem)}
          >
            {dataItem.caseNo}
          </Link>
        }
      />
    );
  }

  function TaskNoColumn(cellProps) {
    const {
      dataItem,
      field,
      //  ...otherProps
    } = cellProps;
    // const navigationAttributes = useTableKeyboardNavigation(cellProps.id);
    return (
      <GridDataCopyCell
        dataItem={dataItem}
        field={field}
        // tdProps={{
        //   ...navigationAttributes,
        //   "aria-selected": "false",
        //   ...otherProps,
        //   ...{ [GRID_COL_INDEX_ATTRIBUTE]: cellProps.columnIndex },
        // }}
        customCell={
          <Link
            onClick={() => {
              setStatus("all");
            }}
            title={dataItem.status === "Draft" ? "View Draft" : dataItem.taskNo}
            to={
              dataItem.status === "Draft"
                ? `${PATHS.createTicket}/${dataItem.ticketId}`
                : `${PATHS.taskDetails}/${dataItem.requestId}`
            }
          >
            {dataItem.status === "Draft" ? "View Draft" : dataItem.taskNo}
          </Link>
        }
      />
    );
  }

  function NormalCell(props) {
    const { dataItem, field, ...otherProps } = props;
    const navigationAttributes = useTableKeyboardNavigation(props.id);
    const _value = dataItem[field];
    const cell = (<td
        {...otherProps}
        {...navigationAttributes}
        {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
        aria-selected="false"
      >
        <span title={_value}>
          <div
            className={`flex items-center  w-full${userSettingsRes?.data.compactRows ? " h-[50px]" : "h-full"}`}
          >
            <p
              className={`inline  w-full ${userSettingsRes?.data.wrapColumnText ? "text-wrap" : "overflow-hidden text-ellipsis text-nowrap"}${
                middleAlignColumns.includes(field) ||
                field.includes("time") ||
                field.includes("at")
                  ? "text-center"
                  : "text-left"
              }`}
            >
              {_value}
            </p>
          </div>
        </span>
      </td>);
      if(field === "resolutionDetails" || field === "remarks"){
             return (<GridDataCopyCell
              dataItem={dataItem}
              field={field}
              customCell={cell}
            />)
          }
    return (
      cell
    );
  }
  const middleAlignColumns = ["status"];
  const getCurrentColumnCell = (elm) => {
    if (elm.columnId === "caseNo") {
      return CaseNoColumn;
    } else if (elm.columnId === "taskNo") {
      return TaskNoColumn;
    } else if (
      elm.columnId !== "createdDateTime" &&
      ticketsConfig?.data.filters.find(
        (item) => item.field === getField(elm.columnId, true)
      )
    ) {
      return ColumnActionsCell;
    }
    return NormalCell;
  };
  const getGridColumns = useMemo(() => {
    const columns = [];
    columnsToRender.forEach((elm) => {
      if (!elm.columnId) {
        return;
      }
      const _currentColumns = {
        // title: elm.label,
        headerCell: () => (
          <span className="k-cell-inner" style={{ height: "100%" }}>
            <span className="k-link">
              <span
                title={elm.label}
                className={`flex items-center font-medium k-column-title ${userSettingsRes?.data.compactRows ? " h-[50px]" : ""}`}
              >
                <p
                  className={`inline w-full ${userSettingsRes?.data.wrapColumnText ? " text-wrap" : " overflow-hidden text-ellipsis text-nowrap"} ${middleAlignColumns.includes(elm.columnId) ? "text-center" : "text-left"}`}
                >
                  {elm.label}
                </p>
              </span>
            </span>
          </span>
        ),
        field: elm.columnId,
        className:
          middleAlignColumns.includes(elm.columnId) ||
          elm.columnId.includes("time") ||
          elm.columnId.includes("at")
            ? "text-center"
            : "text-left",
        headerClassName:
          middleAlignColumns.includes(elm.columnId) ||
          elm.columnId.includes("time") ||
          elm.columnId.includes("at")
            ? "text-center"
            : "text-left",
        width: elm.columnId === "caseNo" ? "170px" : "120px",
        cell: getCurrentColumnCell(elm),
      };
      columns.push(_currentColumns);
    });
    return columns;
  }, [ticketsList, columnsToRender, sortedData]);

  const exportedColumnsTitle = {
    caseNo: "TG Reference Number",
    customerTicketNo: "Bank Reference/Address",
    customer: "Account",
  };
  const onSelectionChange = useCallback(
    (event) => {
      const newSelectedState = getSelectedState({
        event,
        selectedState,
        dataItemKey: DATA_ITEM_KEY,
      });

      setSelectedState(newSelectedState);
    },
    [selectedState]
  );

  const onHeaderSelectionChange = useCallback((event) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    if (checked) {
      event.dataItems.forEach((item) => {
        newSelectedState[idGetter(item)] = checked;
      });
    }
    setSelectedState(newSelectedState);
  }, []);
  const getSelectedRequests = useMemo(() => {
    return tickets.filter((elm) => selectedState[elm.ticketUniqueId]);
  }, [selectedState]);

  const onBulkAssign = (information) => {
    const selectedItems = [];
    Object.keys(selectedState).forEach((elm) => {
      if (selectedState[elm]) {
        selectedItems.push(elm);
      }
    });
    const requestIds = [];
    tickets.forEach((elm) => {
      if (selectedItems.includes(elm.ticketUniqueId)) {
        requestIds.push({ requestId: elm.requestId });
      }
    });
    const payload = {
      cashCenterId: user.CashCenterId,
      operationDate: new Date(),
      routeNo: information.routeNo,
      dispatcherId: information.dispatcherId,
      assigneeId: information.assigneeId,
      secondaryAssigneeId: information.secondaryAssigneeId,
      requests: requestIds,
    };
    bulkAssign(payload);
    setSelectedState({});
  };

  function GroupHeaderCell(props) {
    return (
      props.tdProps && (
        <td {...props.tdProps}>
          {props.children ? (
            <p className="k-reset">
              {props.children.props.children[0]}
              {props.dataItem[props.field]}({props.dataItem.items.length})
            </p>
          ) : null}
        </td>
      )
    );
  }
  return (
    <div className="box-border">
      {gettingTickets ||
      gettingUserColumns ||
      gettingAvailableColumns ||
      gettingUserSettings ||
      bulkAssigning ||
      gettingTicketsConfig ? (
        <Loader />
      ) : (
        <></>
      )}
      <BreadCrumb
        className="mx-4"
        items={[{ text: "Dashboard", to: "/" }, { text: "All Tickets" }]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <DynamicFiltering
              setFilters={(payload) => {
                setFilters(payload);
              }}
              onExcelExport={() => {
                getAllTickets({ ...filters, pageNumber: 0, pageRowCount: 0 });
              }}
              onRefresh={() => {
                setReload(!reload);
              }}
              exportExcel
              exportingExcel={gettingAllTickets}
              selectedRequests={getSelectedRequests}
              assignTeam={onBulkAssign}
            />
          </CardDescription>

          <Grid
            data={sortedData}
            {...dataState}
            onDataStateChange={(e) => {
              e.dataState.skip = 0;
              setDataState(e.dataState);
            }}
            filterable
            groupable
            autoProcessData
            sortable
            pageable
            navigatable
            scrollable="scrollable"
            className={`list-tables-v1
                  ${userSettingsRes?.data.wrapColumnText ? "" : "no-wrap-grid"} ${userSettingsRes?.data.compactRows ? " grid-compact-rows" : ""}`}
            width={userSettingsRes?.data.wrapColumnText ? "100%" : undefined}
            style={{ overflowX: "auto" }}
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            onPageChange={onPageChange}
            expandField="expanded"
            onExpandChange={onExpandChange}
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple",
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
            cells={{
              group: {
                groupHeader: GroupHeaderCell,
              },
            }}
          >
            <GridColumn
              field={SELECTED_FIELD}
              width="50px"
              filterable={false}
              headerSelectionValue={
                tickets.findIndex((item) => !selectedState[idGetter(item)]) ===
                -1
              }
            />
            {getGridColumns.map((elm) => (
              <GridColumn key={`${elm.title}`} {...elm} />
            ))}
          </Grid>
          <ExcelExport
            data={
              allTicketsData?.data.data.map((elm) => ({
                ...elm,
                region: elm.servicePointRegion || elm.region,
              })) || []
            }
            fileName="Tickets.xlsx"
            ref={_exporter}
          >
            {columnsToRender.map((elm) => (
              <GridColumn
                key={`${elm.columnId}`}
                title={exportedColumnsTitle[elm.columnId] || elm.label}
                field={elm.columnId}
              />
            ))}
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
